/* Loosely typed router Link for content-driven hrefs (the route tree is
   language-prefixed and data-driven, so `to` arrives as a plain string). */
import { Link as RouterLink } from "@tanstack/react-router";
import type { AnchorHTMLAttributes, ReactNode } from "react";

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  to: string;
  children?: ReactNode;
};

const Loose = RouterLink as unknown as (props: Props) => ReactNode;

export function Link(props: Props) {
  return <Loose {...props} />;
}
